import { FiltersMap } from '@wix/bex-core';
import { GridSizePreset } from './gridSizePresets';
import { GridBaseState } from './GridBaseState';

export interface GridParentState<T, F extends FiltersMap> {
  _subGrids: GridBaseState<T, F>[] | undefined;
  _sizePreset: GridSizePreset | undefined;
}
